import { useClientRect } from './useClientRect'

export const hooks = {
  useClientRect,
}
